// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+3rzc","row":"styles_row__nbpyG","cell":"styles_cell__slvSl","divider":"styles_divider__bjbmf","content":"styles_content__9BXjm"};